<ion-app
  [dir]="userLanguageService.activeLanguage() && userLanguageService.activeLanguage().dir === 'rtl' ? 'rtl' : 'ltr'">
  @if (enableSidePanel()) {
    <app-left-side-menu />
  }
  <ion-split-pane contentId="main-content">
    <ion-router-outlet id="main-content" mode="ios" class="view-transition-main" />
  </ion-split-pane>
</ion-app>
